<template>
  <div>
    <van-popup
      v-model="isShow"
      position="right"
      :style="{ height: '100%',width:'100%',background: '#f5f5f5' }"
    >
      <div class="info">
        <van-nav-bar :style="{'background-color':'#f9f9f9'}">
          <van-icon size="20" slot="left" @click="closeCreate" name="arrow-left" color="#333" />
          <div slot="title">{{rows.ReceiverName}}</div>
        </van-nav-bar>
        <div class="info-content" ref="PrivateMsgInfo">
          <div v-for="(item,index) in msgList" :key="index">
            <div v-if="item.SenderID===userInfo.UserID">
              <div class="info-right-time">{{item.ShowTimeName}}</div>
              <div class="info-right">
                <div class="info-right-text word-all">{{item.PrivateLetterBody}}</div>
                <img
                  :src="item.ReceiverIcon ? api+item.ReceiverIcon:require('@/assets/basic/'+'yrykb.png')"
                  alt
                  class="info-right-img"
                />
              </div>
            </div>
            <div v-else>
              <div class="info-left-time">{{item.ShowTimeName}}</div>
              <div class="info-left">
                <img
                  :src="item.ReceiverIcon ? api+item.ReceiverIcon:require('@/assets/basic/'+'yrykb.png')"
                  alt
                  class="info-left-img"
                />
                <div class="info-left-text word-all">{{item.PrivateLetterBody}}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="info-keyboard van-hairline--top">
          <input type="text" class="chat-text" v-model.trim="textModel" maxlength="300" />
          <button class="send-btn" @click="sendData" v-if="textModel">发送</button>
          <button class="send-btn no-msg" v-else>发送</button>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
export default {
  name: "letterinfo",
  props: {
    isShow: Boolean,
    rows: Object,
    userInfo: Object
  },
  data() {
    return {
      textModel: "",
      msgList: [],
      api: ""
    };
  },
  computed: {
    msg() {
      return this.$store.state.parentInfo.msgList;
    }
  },
  watch: {
    msg: {
      handler(newVal) {
        this.msgList = newVal;
        let tops = this.$refs.PrivateMsgInfo;
        setTimeout(function() {
          tops.scrollTop = tops.scrollHeight;
        });
      },
      deep: true
    }
  },
  created() {
    this.api = this.xyMApi;
  },
  mounted() {},
  methods: {
    getChatMsg() {},
    closeCreate() {
      this.$emit("listenToChildClose", false);
    },
    sendData() {
      if (this.textModel) {
        this.options = {
          ReceiverID: this.rows.ReceiverID, //接收人
          MessageType: 1,
          MessageBody: this.textModel
        };
        this.$parent.$parent.websocketsend(JSON.stringify(this.options)); //发送
        this.msgList.push({
          ReceiverIcon: this.userInfo.IconFull,
          MessageType: 2,
          SenderID: this.userInfo.UserID,
          PrivateLetterBody: this.textModel
        });
        let letterList = this.$store.state.parentInfo.childList;
        for (let i = 0, len = letterList.length; i < len; i++) {
          if (letterList[i].ReceiverID === this.rows.ReceiverID) {
            letterList[i].PrivateLetterBody = this.textModel;
          }
        }
        this.$store.commit("parentInfo/changeMsgList", this.msgList);
        this.textModel = "";
        let tops = this.$refs.PrivateMsgInfo;
        setTimeout(function() {
          tops.scrollTop = tops.scrollHeight;
        });
      }
    }
  }
};
</script>
<style lang="less" scoped>
.info {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .info-content {
    flex: 1;
    overflow-y: auto;
    background: #fff;
    padding: 40px;
    img {
      width: 74px;
      height: 74px;
      background: #eee;
      border-radius: 8px;
    }
    .info-left-time {
      color: #ccc;
      padding-left: 90px;
      font-size: 22px;
      margin-bottom: 10px;
    }
    .info-right-time {
      color: #ccc;
      text-align: right;
      padding-right: 90px;
      font-size: 22px;
      margin-bottom: 10px;
    }
    .info-right {
      display: flex;
      justify-content: flex-end;
      margin-bottom: 50px;
      .info-right-img {
        margin-left: 15px;
      }
      .info-right-text {
        max-width: 400px;
        min-height: 40px;
        padding: 20px;
        background: #4196ff;
        border-radius: 20px 5px 20px 20px;
        font-size: 28px;
        color: #fff;
      }
    }
    .info-left {
      display: flex;
      justify-content: flex-start;
      margin-bottom: 50px;
      .info-left-img {
        margin-right: 15px;
      }
      .info-left-text {
        max-width: 400px;
        min-height: 40px;
        padding: 20px;
        background: #f2f3f9;
        border-radius: 5px 20px 20px 20px;
        font-size: 28px;
      }
    }
  }
  .info-keyboard {
    height: 120px;
    width: 100%;
    background: #f6f6f6;
    display: flex;
    padding: 0 40px;
    align-items: center;
  }
  .chat-text {
    background: #fff;
    border: none;
    height: 80px;
    border-radius: 38px;
    width: 536px;
    padding: 0 20px;
    margin-right: 20px;
    font-size: 28px;
  }
  .send-btn {
    border: 0;
    background: #4196ff;
    color: #fff;
    width: 134px;
    height: 60px;
    border-radius: 38px;
    font-size: 28px;
  }
  .no-msg {
    background: #ccc;
  }
}
</style>